// nakamaClient.js — Petit client Nakama REST côté navigateur (auth device + leaderboards).
// Réutilisé par la page Classements. Tolérant aux pannes (renvoie [] si indispo).
import { nakama } from '../config/nakama';

let sessionToken = null;

// Un token JWT Nakama expire (1h). On vérifie l'expiration côté client pour NE PAS réutiliser
// un token périmé en cache (sinon 401 en boucle sur la présence/leaderboards).
export function isExpired(token) {
  try {
    const p = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return !p.exp || (p.exp - 30) < (Date.now() / 1000); // marge 30s
  } catch { return true; }
}

function deviceId() {
  const k = 'vg_appstore_device';
  let id = null;
  try { id = localStorage.getItem(k); } catch { /* ignore */ }
  if (!id) { id = 'as-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9); try { localStorage.setItem(k, id); } catch { /* ignore */ } }
  return id;
}

export async function login() {
  if (!nakama.enabled) return null;
  if (sessionToken && !isExpired(sessionToken)) return sessionToken;
  sessionToken = null; // périmé → on ré-authentifie
  try {
    const res = await fetch(`${nakama.url}/v2/account/authenticate/device?create=true`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Basic ' + btoa(nakama.key + ':') },
      body: JSON.stringify({ id: deviceId() }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    sessionToken = data.token;
    return sessionToken;
  } catch { return null; }
}

// Renvoie les meilleurs scores d'un leaderboard : [{ rank, username, score }]
export async function topScores(leaderboardId, limit = 10) {
  if (!nakama.enabled) return [];
  const token = await login();
  if (!token) return [];
  try {
    const res = await fetch(`${nakama.url}/v2/leaderboard/${encodeURIComponent(leaderboardId)}?limit=${limit}`, {
      headers: { Authorization: 'Bearer ' + token },
    });
    if (!res.ok) return [];
    const data = await res.json();
    const records = data.records || [];
    // Le record Nakama ne garde qu'un INSTANTANÉ du username au moment du score (souvent vide/aléatoire
    // pour les invités) → on va chercher le VRAI pseudo courant (display_name/username) par owner_id.
    const ids = [...new Set(records.map((r) => r.owner_id).filter(Boolean))];
    const names = {};
    if (ids.length) {
      try {
        const q = ids.map((id) => 'ids=' + encodeURIComponent(id)).join('&');
        const ur = await fetch(`${nakama.url}/v2/user?${q}`, { headers: { Authorization: 'Bearer ' + token } });
        if (ur.ok) { const ud = await ur.json(); (ud.users || []).forEach((u) => { names[u.id] = u.display_name || u.username || ''; }); }
      } catch { /* */ }
    }
    // Un « vrai » pseudo n'est pas un identifiant hexadécimal/UUID. Sinon on affiche un nom lisible joueur_xxxxxx.
    const isHexId = (s) => /^[0-9a-f-]{6,}$/i.test(s || '');
    const friendly = (r) => {
      const real = names[r.owner_id];
      if (real && !isHexId(real)) return real;
      if (r.username && !isHexId(r.username)) return r.username;
      return 'joueur_' + (r.owner_id ? r.owner_id.replace(/-/g, '').slice(0, 6) : Math.random().toString(36).slice(2, 8));
    };
    return records.map((r, i) => {
      let premium = false;
      try { const m = typeof r.metadata === 'string' ? JSON.parse(r.metadata) : (r.metadata || {}); premium = !!(m && (m.premium === true || m.premium === 'true')); } catch { /* */ }
      return { rank: r.rank || i + 1, username: friendly(r), score: r.score, premium, ownerId: r.owner_id };
    });
  } catch { return []; }
}
